import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { houseRedirectTarget } from '../utils/houseLink';

// The /house route (App.js): the short link to wherever the Claude House lives.
export default function HouseRedirect() {
  const { search } = useLocation();
  return <Navigate to={houseRedirectTarget(search)} replace />;
}
